// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { sepolia as _sepolia } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the sepolia chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 11155111
 * Chain Name: Sepolia
 * Default Block Explorer: https://sepolia.etherscan.io
 * Default RPC URL: https://rpc.sepolia.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { sepolia } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: sepolia,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const sepolia = createCommon({
	..._sepolia,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
